import Link from '@mui/material/Link'
import styled from '@mui/material/styles/styled'

export const ViewDetailsLink = styled(Link, {
  name: 'ViewDetailsLink',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})({
  color: '#19305A',
  cursor: 'pointer',
})
